import React from "react";
import { progressPercent } from "./helpers";

interface Props {
  earned: number;
  total: number;
  label: string;
}

const BadgeProgress: React.FC<Props> = ({ earned, total, label }) => {
  const percent = progressPercent(earned, total);

  return (
    <div className="bd-progress" aria-label={`${earned} of ${total} ${label}`}>
      <div className="bd-progress-text">
        <strong>{earned}</strong> of <span>{total}</span> badges earned
      </div>
      <div className="bd-progress-bar" aria-hidden="true">
        <div className="bd-progress-fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};

export default BadgeProgress;
